export const environment = {
  production: false,
  apiBaseUrl: 'https://api.dev.zhmyak.ru',
  sentry: {
    dsn: '',
    environment: 'development',
    release: '',
  },
  /**
   * BE-1420: инструкция сотрудника (документ из public/). Пустая строка прячет пункт
   * меню целиком — на стенде без выложенного файла ссылка вела бы в 404.
   *
   * Сам файл — копия: собирается в тулките оператора (`ZhmyakV2/docs/onboarding-manager.md`
   * → `build_onboarding_html.py`) и перекладывается в `public/onboarding-manager.html`.
   * Инструкцию правят там, иначе копии разъедутся.
   */
  managerGuideUrl: '/onboarding-manager.html',
  /** BE-314: URL для связи с менеджером (Telegram-бот/чат поддержки) */
  managerContactUrl: 'https://t.me/zhmyak_support',
  /**
   * BE-962: прайс сторонней услуги оформления карточки (PDF-ассет из public/).
   *
   * BE-1369: блок услуги закомментирован в форме акции — поле и ассет ждут возврата
   * блока, чистить их вместе с `cardServiceTelegramUrl` нельзя.
   */
  cardServicePriceUrl: '/card-service-price.pdf',
  /** BE-962: Telegram-контакт для заказа услуги оформления карточки. */
  cardServiceTelegramUrl: 'https://t.me/CardStrategist',
  /** BE-1364: демо-витрина; пустая строка выключает кнопки (см. environment.ts). */
  marketplaceDemoUrl: 'https://dev.zhmyak.ru/demo/showcase/store'
};
